module.exports = __webpack_public_path__ + "img/website.d89739cb.png";